import axios from 'axios';
import config from '../config';
import authHeader from './auth-header';

export const resolveAppointmentVoucher = async (values) => {
  const response = await axios.post(
    config.API_URL + 'afterlogin/appointment/voucher/resolve', values,
    {headers: authHeader()},
  );
  const voucher = response?.data?.data;
  if (!voucher?.voucher_to_id || !voucher?.code || !(Number(voucher?.remaining_balance?.amount_minor) > 0)) {
    throw new Error('Unable to verify this voucher. Please try again.');
  }
  return voucher;
};
